<template>
  <div>
    <h2>
      Listado de personas no recontratables
    </h2>
    <app-table
      @change-pagination="onChangePagination"
      @change-search="onChangeSearch"
      :total="total">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="employee_code"
          label="Cod">
        </el-table-column>
        <el-table-column
          prop="card"
          label="Identidad">
        </el-table-column>
        <el-table-column
          prop="names"
          label="Nombre">
          <template slot-scope="scope">
            <p>{{scope.row.names +' '+scope.row.last_names}}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="cost_center"
          label="Último Centro de Costos">
        </el-table-column>
        <el-table-column
          prop="blacklist_reason"
          label="Motivo">
        </el-table-column>
      </el-table>
    </app-table>
  </div>

</template>
<script>
  import AppTable from '../../components/Table'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {baseApi} from '../../configs/urls'
  import {parseError} from '../../packages/Helpers'

  export default {
    extends: BaseCrud,
    name: 'employees-blacklist',
    components: {
      AppTable
    },
    data () {
      return {
        baseUrl: baseApi + '/blacklist',
        basePermission: 'employees'
      }
    },
    methods: {
      getEmployeesData () {
        this.$http.get(this.baseUrl)
          .then(
            (res) => {
              this.employees = res.body
            },
            (res) => {
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
            }
          )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/blacklist/blacklist.vue